<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M45.8,2.2h-14.8c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4h2.1c.2,0,.3,0,.4.3,0,.2,0,.3,0,.5L11.5,42.5c-.2.3-.5.4-.8.4h-5.5c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4h14.8c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4h-2.1c-.2,0-.3,0-.4-.3,0-.2,0-.3,0-.5L39.5,7.5c.2-.3.5-.4.8-.4h5.5c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>